<template>
  <div class="creative-desc">
    <ColumnBlock :title="title" @clear="onClear" @show-config-modal="onShowConfigModal">
      <div slot="title" class="block-title">
        <h4>{{ props.title }}</h4>
        <span>{{ configForm.descriptions.length }}/50 </span>
      </div>

      <div class="desc-items">
        <div v-for="(item, index) in descriptions" :key="item.targetingId" class="desc-item">
          <span>{{ item.packName }}</span>
          <em @click="onDescItemRemove(index)" class="close-icon el-icon-error"></em>
        </div>
      </div>
    </ColumnBlock>

    <TitleSelectModal
      v-model="showDescInfoModal"
      :media-id="MEDIAS.GDT"
      :op-id="opId"
      :before-confirm="onTitleSelectorBeforeConfirm"
      @confirm="onTitleSelectorConfirm"
    />
  </div>
</template>

<script setup>
import { computed, ref, toRefs, inject } from 'vue'
import { MEDIAS } from '@/common/js/constants.js'
import ColumnBlock from '@/views/create/bytedance/components/layout/block.vue'
// import ConfigDrawer from '@/views/create/bytedance/components/layout/drawer.vue'
// import WxgamePlayablePlaceholder from './components/wxgame-playable-placeholder.vue'

import TitleSelectModal from '@/components/title-selector/title-selector-modal.vue'
import { useGdtCreativeComputes } from '../../hooks/utils/creative.js'
const { opId } = inject('localStates')

// eslint-disable-next-line
const props = defineProps({
  title: String
})
const { title } = toRefs(props)

const { configForm, updateConfigForm } = inject('configForm')
const descriptions = computed(() => configForm.value.descriptions)
const creativeForm = computed(() => configForm.value.creativeForm)
const { isWxGamePlayable } = useGdtCreativeComputes(creativeForm)

function onTitleSelectorBeforeConfirm(descs) {
  if (isWxGamePlayable.value) {
    if (descs.some((desc) => desc.content.length > 1)) {
      return Promise.reject(new Error('试玩结束页只能选择文案个数等于1的文案包'))
    }
  }
  return Promise.resolve()
}
function onTitleSelectorConfirm(e) {
  const existIds = descriptions.value.map((item) => item.id)
  const newRows = {}

  for (const item of e) {
    if (existIds.includes(item.id)) continue
    if (newRows[item.id]) continue
    newRows[item.id] = item
  }
  const newRowsArr = Object.values(newRows)
  updateConfigForm({
    ...configForm.value,
    descriptions: descriptions.value.concat(newRowsArr).slice(0, 100)
  })
}

const showDescInfoModal = ref(false)
function onDescItemRemove(index) {
  const descs = descriptions.value.filter((item, i) => i !== index)

  updateConfigForm({
    ...configForm.value,
    descriptions: descs
  })
}
function onShowConfigModal() {
  showDescInfoModal.value = true
}
function onClear() {
  updateConfigForm({
    ...configForm.value,
    descriptions: []
  })
}
</script>

<style lang="scss" scoped>
.desc-preview {
  height: 380px;
  overflow: auto;
}
.config-count {
  font-size: 14px;
  margin-left: 20px;
}

.creative-desc {
  .desc-items {
    padding: 10px;
    height: 380px;
    overflow: auto;
  }

  .desc-item {
    display: flex;
    padding: 6px 10px;
    justify-content: space-between;
    align-items: center;
    background: #eee;
    margin-bottom: 10px;
    border-radius: 4px;
  }

  .close-icon {
    cursor: pointer;
    font-size: 13px;
  }
}
</style>
